import React from "react";
import Confetti from "react-confetti";

const ConfettiDisplay = () => {
  return (
    <div className="relative min-h-screen w-full bg-gray-900 flex flex-col items-center justify-center overflow-hidden">
      <Confetti
        width={window.innerWidth} // Full width of the window
        height={window.innerHeight} // Full height of the window
        numberOfPieces={200} // Adjust the number of confetti pieces as needed
      />
      <div className="flex flex-col justify-center items-center">
        <div className="relative w-72 h-72 md:w-60 md:h-60 sm:w-48 sm:h-48 bg-yellow-500 rounded-full border-4 border-yellow-600 shadow-lg">
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-black text-2xl md:text-xl sm:text-lg font-bold">100 coins</span>
          </div>
        </div>
        <h1 className="text-4xl md:text-3xl sm:text-2xl font-bold text-white mt-8">
          Congratulations!
        </h1>
        <p className="text-lg md:text-base sm:text-sm text-white mt-4">
          Earn 10 coins every day by coming to gym!
        </p>
        <p className="text-center text-lg md:text-base sm:text-sm text-white mt-4">
          Plus, earn more points when you refer a friend to our gym! If they stay for a month, you get 10 points, 3 months you get 30 points, 6 months you get 60 points, and 1 year you get 100 points! That's a total of 200 points!
        </p>
        <p className="text-center text-lg md:text-base sm:text-sm text-white mt-4">
          Reach the following milestones to earn great gym gifts:
        </p>
        <ul className="text-lg md:text-base sm:text-sm text-white mt-2">
          <li>🏆 250 coins: Free Gym Towel</li>
          <li>🎁 500 coins: Water Bottle with your Gym Logo</li>
          <li>🎉 750 coins: Gym Bag or Resistance Bands</li>
        </ul>
        <p className="text-center text-lg md:text-base sm:text-sm text-white mt-4">
          Check your account for more details on how to redeem your rewards!
        </p>
      </div>
    </div>
  );
};

export default ConfettiDisplay;

